export default {
    // 用户IP记录-IP记录查询
    admin_selectUserLogin: {
        url: '/java-api/admin/ipLocation/selectUserLogin',
        method: 'post'
    },
    // 用户IP记录-IP记录查询-IP详情
    admin_selectIpDetail: {
        url: '/java-api/admin/ipLocation/selectIpDetail',
        method: 'post'
    },
    // 学校管理-分校管理-查询
    admin_eduCampusSelectList: {
        url: '/java-api/admin/eduCampus/selectList',
        method: 'post'
    },
    // 开启/禁用分校区
    admin_updateDisabledState: {
        url: '/java-api/admin/eduCampus/updateDisabledState',
        method: 'post'
    },
    // 用户IP记录-IP记录查询-用户详情
    admin_selectUserDetail: {
        url: '/java-api/admin/ipLocation/selectUserDetail',
        method: 'post'
    },
    // 机构分析-查询 /eduArea/selectList
    admin_selectEduAreaList: {
        url: '/java-api/admin/eduArea/selectList',
        method: 'post'
    },
    // 机构分析-机构详情-人员信息 /ipLocation/selectEduIpDetail
    admin_selectEduIpDetail: {
        url: '/java-api/admin/ipLocation/selectEduIpDetail',
        method: 'post'
    },
    // 机构分析-机构详情-IP信息 /ipLocation/selectEduIpMsg
    admin_selectEduIpMsg: {
        url: '/java-api/admin/ipLocation/selectEduIpMsg',
        method: 'post'
    },
    // 机构分析-机构详情-人员信息-IP登录记录 /ipLocation/selectIpLoginRecord
    admin_selectIpLoginRecord: {
        url: '/java-api/admin/ipLocation/selectIpLoginRecord',
        method: 'post'
    },
    // 保存或更新IP信息 /ipLocation/saveOrUpdateIp 类型（0区县，1街道）
    admin_saveOrUpdateIp: {
        url: '/java-api/admin/ipLocation/saveOrUpdateIp',
        method: 'post'
    },
    // 机构分析-更新机构状态 /eduArea/updateState
    admin_updateState: {
        url: '/java-api/admin/eduArea/updateState',
        method: 'post'
    },
    // 机构分析-更新地址 /eduArea/updateAddress
    admin_updateAddress: {
        url: '/java-api/admin/eduArea/updateAddress',
        method: 'post'
    },
    // 机构分析-设为/取消常用地址 /eduArea/setAddress
    admin_setAddress: {
        url: '/java-api/admin/eduArea/setAddress',
        method: 'post'
    },
    // 机构分析-地图详情 /ipLocation/selectEduLocation
    admin_selectEduLocation: {
        url: '/java-api/admin/ipLocation/selectEduLocation',
        method: 'post'
    },
    // 机构分析-地图详情-用户详情 /ipLocation/selectEduLogin
    admin_selectEduLogin: {
        url: '/java-api/admin/ipLocation/selectEduLogin',
        method: 'post'
    },
    // 全国机构分布 /eduArea/selectEduDist
    admin_selectEduDist: {
        url: '/java-api/admin/eduArea/selectEduDist',
        method: 'post'
    },
    // 全国机构分布-地图查询 /eduArea/selectEduMap
    admin_selectEduMap: {
        url: '/java-api/admin/eduArea/selectEduMap',
        method: 'post'
    },
    // 用户IP记录-全国学生分布-查询 /stuCommonLoginArea/selectList
    admin_stuCommonLoginAreaSelectList: {
        url: '/java-api/admin/stuCommonLoginArea/selectList',
        method: 'post'
    },
    // 用户IP记录-全国学生分布-详情 /stuCommonLoginArea/selectDetail
    admin_stuCommonLoginAreaSelectDetail: {
        url: '/java-api/admin/stuCommonLoginArea/selectDetail',
        method: 'post'
    },
    // 用户IP记录-IP封禁管理-查询 /ipBanRecord/selectList
    admin_ipBanRecordSelectList: {
        url: '/java-api/admin/ipBanRecord/selectList',
        method: 'post'
    },
    // 用户IP记录-IP封禁管理-手动封禁 /ipBanRecord/save
    admin_ipBanRecordSave: {
        url: '/java-api/admin/ipBanRecord/save',
        method: 'post'
    },
    // 用户IP记录-IP封禁管理-封禁/解除封禁 /ipBanRecord/updateStatus
    admin_ipBanRecordUpdateStatus: {
        url: '/java-api/admin/ipBanRecord/updateStatus',
        method: 'post'
    },
    // 用户IP记录-IP封禁管理-修改封禁原因 /ipBanRecord/updateRemark
    admin_ipBanRecordUpdateRemark: {
        url: '/java-api/admin/ipBanRecord/updateRemark',
        method: 'post'
    },
    // 学校管理-员工管理-查询 /user/selectEmployList
    admin_userSelectEmployList: {
        url: '/java-api/admin/user/selectEmployList',
        method: 'post'
    },
    //学校管理-员工管理-查询角色列表 /admin/eduRole/queryList
    admin_eduRoleQueryList: {
        url: '/java-api/auth/admin/eduRole/queryList',
        method: 'post'
    },

    // 系统设置-系统通知-课程反馈 /lessonFeedback/selectList
    admin_lessonFeedbackSelectList: {
        url: '/java-api/admin/lessonFeedback/selectList',
        method: 'post'
    },
    // 系统设置-系统通知-信奥反馈 /ojFeedback/selectList
    admin_ojFeedbackSelectList: {
        url: '/java-api/admin/ojFeedback/selectList',
        method: 'post'
    },
    // 系统设置-系统通知-课程反馈-回复 /lessonFeedback/reply
    admin_lessonFeedbackReply: {
        url: '/java-api/admin/lessonFeedback/reply',
        method: 'post'
    },
    // 系统设置-系统通知-信奥反馈-回复 /ojFeedback/reply
    admin_ojFeedbackReply: {
        url: '/java-api/admin/ojFeedback/reply',
        method: 'post'
    },
    // 系统设置-系统通知-反馈标签-查询 /feedbackTag/selectListByType
    admin_feedbackTagSelectListByType: {
        url: '/java-api/admin/feedbackTag/selectListByType',
        method: 'post'
    },
    // 系统设置-系统通知-反馈标签-保存 /feedbackTag/saveBatch
    admin_feedbackTagSaveBatch: {
        url: '/java-api/admin/feedbackTag/saveBatch',
        method: 'post'
    },
    // 系统设置-系统通知-反馈标签-修改 /feedbackTag/update
    admin_feedbackTagUpdate: {
        url: '/java-api/admin/feedbackTag/update',
        method: 'post'
    },
    // 体验校区-体验账号-一键修改 /user/updateTryEduUserName
    admin_updateTryEduUserName: {
        url: '/java-api/admin/user/updateTryEduUserName',
        method: 'post'
    },
    // 重置用户手机号 /user/resetPhoneNum
    admin_resetPhoneNum: {
        url: '/java-api/admin/user/resetPhoneNum',
        method: 'post'
    },
    // 发送验证短信 /user/sendSms
    admin_userSendSms: {
        url: '/java-api/admin/user/sendSms',
        method: 'post'
    },
    // 校验验证码 /user/verifyCode
    admin_userVerifyCode: {
        url: '/java-api/admin/user/verifyCode',
        method: 'post'
    },
    // 更改用户忽略手机号验证状态 /user/updateIgnoreVerifyFlag
    admin_userUpdateIgnoreVerifyFlag: {
        url: '/java-api/admin/user/updateIgnoreVerifyFlag',
        method: 'post'
    }
}
